export default {
  translation_agencies: state => {
    return state.translation_agencies.translation_agencies
  },
  total: state => {
    return state.translation_agencies.total
  }
}